import { Routes } from '@angular/router';
import { authRouteGuard } from './guards/auth-route.guard';

const rawAppRoutes: Routes = [
    { path: '', redirectTo: '/Login', pathMatch: 'full' },
    {
        path: 'Login',
        loadComponent: () => import('./login/login.component').then(m => m.LoginComponent)
    },
    {
        path: 'Auth',
        loadComponent: () => import('./auth/auth.component').then(m => m.AuthComponent),
    },
    {
        path: 'SSO',
        loadComponent: () => import('./sso/sso.component').then(m => m.SSOComponent),
    },
    {
        path: 'EntityDashboard',
        loadComponent: () => import('./pages/entitydashboard/entitydashboard.component').then(m => m.EntitydashboardComponent),
    },
    {
        path: 'ComplianceDashboard',
        loadComponent: () => import('./pages/compliance-dashboard/compliance-dashboard.component').then(m => m.ComplianceDashboardComponent),
    },
    {
        path: 'ClientDashboard',
        loadComponent: () => import('./pages/client-dashboard/client-dashboard/client-dashboard.component').then(m => m.ClientDashboardComponent),
    },
    {
        path: 'ApplicabilityCheck',
        loadComponent: () => import('./pages/licenses/applicability-check/applicability-check.component').then(m => m.ApplicabilityCheckComponent),
    },
    {
        // Payroll Compliances tab of Applicability Check — its own component, reached via
        // the app-tabs bar alongside Labour Law Compliances.
        path: 'ApplicabilityCheckPayroll',
        loadComponent: () => import('./pages/licenses/applicability-check-payroll/applicability-check-payroll.component').then(m => m.ApplicabilityCheckPayrollComponent),
    },
    {
        path: 'RegistrationSummary',
        loadComponent: () => import('./pages/licenses/registrations/registrations.component').then(m => m.RegistrationsComponent),
    },
    {
        path: 'RegistrationsRepository',
        loadComponent: () => import('./pages/licenses/registrations-repository/registrations-repository.component').then(m => m.RegistrationsRepositoryComponent),
    },
    {
        path: 'AddRegistrationRepository',
        loadComponent: () => import('./pages/licenses/add-registration-repository/add-registration-repository.component').then(m => m.AddRegistrationRepositoryComponent),
    },
    {
        path: 'PFRegistrations',
        loadComponent: () => import('./pages/licenses/pf-registrations/pf-registrations.component').then(m => m.PfRegistrationsComponent),
    },
    {
        path: 'ESICRegistrations',
        loadComponent: () => import('./pages/licenses/esic-registrations/esic-registrations.component').then(m => m.EsicRegistrationsComponent),
    },
    {
        path: 'PTRegistrations',
        loadComponent: () => import('./pages/licenses/pt-registrations/pt-registrations.component').then(m => m.PtRegistrationsComponent),
    },
    {
        path: 'LWFRegistrations',
        loadComponent: () => import('./pages/licenses/lwf-registrations/lwf-registrations.component').then(m => m.LwfRegistrationsComponent),
    },
    {
        path: 'NFHRegistrations',
        loadComponent: () => import('./pages/licenses/nfh-registrations/nfh-registrations.component').then(m => m.NfhRegistrationsComponent),
    },
    {
        path: 'Workspace',
        loadComponent: () => import('./pages/workspace/workspace.component').then(m => m.WorkspaceComponent),
    },
    {
        path: 'ChallanActivity',
        loadComponent: () => import('./pages/workspace/challan-activity/challan-activity.component').then(m => m.ChallanActivityComponent),
    },
    {
        path: 'ChallanActivityEdit',
        loadComponent: () => import('./pages/workspace/challan-activity/challan-activity-edit/challan-activity-edit.component').then(m => m.ChallanActivityEditComponent),
    },
    {
        path: 'RCPDeletion',
        loadComponent: () => import('./pages/registration-licenses/rcp-deletion/rcp-deletion.component').then(m => m.RcpDeletionComponent),
    },
    {
        path: 'DispenceryMaster',
        loadComponent: () => import('./pages/esic-tic/dispencery-master/dispencery-master.component').then(m => m.DispenceryMasterComponent),
    },
    {
        path: 'SubcodeMaster',
        loadComponent: () => import('./pages/esic-tic/esic-subcode/esic-subcode.component').then(m => m.EsicSubcodeComponent),
    },
    {
        path: 'ESICInputs',
        loadComponent: () => import('./pages/esic-tic/esicinputs/esicinputs.component').then(m => m.ESICInputsComponent),
    },
    {
        path: 'ESICReport',
        loadComponent: () => import('./pages/esic-tic/esicreport/esicreport.component').then(m => m.ESICReportComponent),
    },
    {
        path: 'LocationMaster',
        loadComponent: () => import('./pages/manage-masters/location-master/location-master.component').then(m => m.LocationMasterComponent),
    },
    {
        path: 'DesignationMaster',
        loadComponent: () => import('./pages/manage-masters/designation-master/designation-master.component').then(m => m.DesignationMasterComponent),
    },
    {
        path: 'LeaveTypeMaster',
        loadComponent: () => import('./pages/manage-masters/leave-type-master/leave-type-master.component').then(m => m.LeaveTypeMasterComponent),
    },
    {
        path: 'StatutoryMaster',
        loadComponent: () => import('./pages/manage-masters/statutory-master/statutory-master.component').then(m => m.StatutoryMasterComponent),
    },
    {
        path: 'ChallanPTSlab',
        loadComponent: () => import('./pages/manage-masters/challan-pt-slab/challan-pt-slab.component').then(m => m.ChallanPtSlabComponent),
    },
    {
        path: 'PayCodeMapping',
        loadComponent: () => import('./pages/manage-masters/paycode-master/paycode-master.component').then(m => m.PaycodeMasterComponent),
    },
    {
        path: 'MinimumWagesPeriod',
        loadComponent: () => import('./pages/minimum-wages/minimum-wages-period/minimum-wages-period.component').then(m => m.MinimumWagesPeriodComponent),
    },
    {
        path: 'IndustrySkillDesignationMapping',
        loadComponent: () => import('./pages/minimum-wages/industry-skill-designation-mapping/industry-skill-designation-mapping.component').then(m => m.IndustrySkillDesignationMappingComponent),
    },
    {
        path: 'ZoneLocationMapping',
        loadComponent: () => import('./pages/minimum-wages/zone-location-mapping/zone-location-mapping.component').then(m => m.ZoneLocationMappingComponent),
    },
    {
        path: 'Notifications',
        loadComponent: () => import('./pages/minimum-wages/notifications/notifications.component').then(m => m.NotificationsComponent),
    },
    {
        path: 'MinimumWages',
        loadComponent: () => import('./pages/minimum-wages/minimum-wages/minimum-wages.component').then(m => m.MinimumWagesComponent),
    },
    {
        path: 'ManageEmployee',
        loadComponent: () => import('./pages/onboard-employee/manage-employee/manage-employee.component').then(m => m.ManageEmployeeComponent),
    },
    {
        path: 'EmployeeMasterUpload',
        loadComponent: () => import('./pages/onboard-employee/employee-master-upload/employee-master-upload.component').then(m => m.EmployeeMasterUploadComponent),
    },
    {
        path: 'EmployeeMasterReport',
        loadComponent: () => import('./pages/onboard-employee/employee-report/employee-report.component').then(m => m.EmployeeReportComponent),
    },
    {
        path: 'EmployeeCTCMaster',
        loadComponent: () => import('./pages/onboard-employee/employee-ctc/employee-ctc.component').then(m => m.EmployeeCtcComponent),
    },
    {
        path: 'MaternityMaster',
        loadComponent: () => import('./pages/onboard-employee/maternity-master/maternity-master.component').then(m => m.MaternityMasterComponent),
    },
    {
        path: 'PremiseMaster',
        loadComponent: () => import('./pages/onboard-entity/premise-master/premise-master.component').then(m => m.PremiseMasterComponent),
    },
    {
        path: 'UserBranchMapping',
        loadComponent: () => import('./pages/onboard-entity/user-branch-mapping/user-branch-mapping.component').then(m => m.UserBranchMappingComponent),
    },
    {
        path: 'AddNotice',
        loadComponent: () => import('./pages/notices/addnotices/addnotices.component').then(m => m.AddnoticesComponent),
    },
    {
        path: 'ComplianceAssignment',
        loadComponent: () => import('./pages/onboard-entity/compliance-assignment/compliance-assignment.component').then(m => m.ComplianceAssignmentComponent),
    },
    {
        path: 'ManageCompliances',
        loadComponent: () => import('./pages/onboard-entity/manage-compliances/manage-compliances.component').then(m => m.ManageCompliancesComponent),
    },
    {
        path: 'CustomerMaster',
        loadComponent: () => import('./pages/onboard-entity/customer-master/customer-master.component').then(m => m.CustomerMasterComponent),
    },
    {
        path: 'EntityMaster',
        loadComponent: () => import('./pages/onboard-entity/entity-master/entity-master.component').then(m => m.EntityMasterComponent),
    },
    {
        path: 'ActivityCalender',
        loadComponent: () => import('./pages/master-scoping/activity-calender/activity-calender.component').then(m => m.ActivityCalenderComponent),
    },
    {
        path: 'AgreementDetails',
        loadComponent: () => import('./pages/master-scoping/agreement-details-master/agreement-details-master.component').then(m => m.AgreementDetailsMasterComponent),
    },
    {
        path: 'MasterScoping',
        loadComponent: () => import('./pages/master-scoping//master-scoping-setup//master-scoping-setup.component').then(m => m.MasterScopingSetupComponent),
    },
    {
        path: 'CommercialMapping',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping/commercial-mapping.component').then(m => m.CommercialMappingComponent),
    },
    {
        path: 'ReviewRegulatoryAbstracts',
        loadComponent: () => import('./pages/abstract/review-regulatory-abstracts/review-regulatory-abstracts.component').then(m => m.ReviewRegulatoryAbstractsComponent),
    },
    {
        path: 'Master_Abstracts',
        loadComponent: () => import('./pages/abstract/master-abstracts/master-abstracts.component').then(m => m.MasterAbstractsComponent),
    },
    {
        path: 'LabourDepartmentAddress',
        loadComponent: () => import('./pages/abstract/labour-department-address/labour-department-address.component').then(m => m.LabourDepartmentAddressComponent),
    },
    {
        path: 'ActivityCalender',
        loadComponent: () => import('./pages/master-scoping/activity-calender/activity-calender.component').then(m => m.ActivityCalenderComponent),
    },
    {
        path: 'UserMaster',
        loadComponent: () => import('./pages/onboard-entity/user-master/user-master.component').then(m => m.UserMasterComponent),
    },
    {
        path: 'ComplianceAssignmentReport',
        loadComponent: () => import('./pages/reports/compliance-assignment-report/compliance-assignment-report.component').then(m => m.ComplianceAssignmentReportComponent),
    },
    {
        path: 'LCMyComplianceDocumentComponent',
        loadComponent: () => import('./pages/statutorydocument/my-compliance-document/my-compliance-document.component').then(m => m.MyComplianceDocumentComponent),
    },
    {
        path: 'ComplianceStatusReport',
        loadComponent: () => import('./pages/reports/compliance-status-report/compliance-status-report.component').then(m => m.ComplianceStatusReportComponent),
    },
    {
        path: 'DigitalSignature',
        loadComponent: () => import('./pages/my-documents/digital-signature/digital-signature.component').then(m => m.DigitalSignatureComponent),
    },
    {
        path: 'VarianceReport',
        loadComponent: () => import('./pages/reports/variance-report/variance-report.component').then(m => m.VarianceReportComponent),
    },
    {
        path: 'Notices',
        loadComponent: () => import('./pages/notices/notices/notices.component').then(m => m.NoticesComponent),
    },
    {
        path: 'ECRMaster',
        loadComponent: () => import('./pages/ecr/ecr-master/ecr-master.component').then(m => m.EcrMasterComponent),
    },
    {
        path: 'CLRAAssignment',
        loadComponent: () => import('./pages/reports/clra-assignment-report/clra-assignment-report.component').then(m => m.CLRAAssignmentReportComponent),
    },
    {
        path: 'DocumentGeneration',
        loadComponent: () => import('./pages/workspace/document-generation/document-generation.component').then(m => m.DocumentGenerationComponent),
    },
    {
        path: 'EcrConfirmation',
        loadComponent: () => import('./pages/ecr/ecr-confirmation/ecr-confirmation.component').then(m => m.EcrConfirmationComponent),
    },
    {
        path: 'ClientRegistrationRepository',
        loadComponent: () => import('./pages/my-documents/client-registration-repository/client-registration-repository.component').then(m => m.ClientRegistrationRepositoryComponent),
    },
    {
        path: 'RegistrationRepository',
        loadComponent: () => import('./pages/my-documents/registration-repository/registration-repository.component').then(m => m.RegistrationRepositoryComponent),
    },
    {
        path: 'ClientCommercialSetup',
        loadComponent: () => import('./pages/invoice-files/Setup/client-commercial-setup/client-commercial-setup.component').then(m => m.ClientCommercialSetupComponent),
    },
    {
        path: 'ClientStatutoryDocument',
        loadComponent: () => import('./pages/statutorydocument/client-statutory-document/client-statutory-document.component').then(m => m.ClientStatutoryDocumentComponent),
    },
    {
        path: 'LC_MIS',
        loadComponent: () => import('./pages/mis-document/mis-document/mis-document.component').then(m => m.MisDocumentComponent),
    },
    {
        path: 'InvoiceDetails',
        loadComponent: () => import('./pages/invoice-files/invoice-details/invoice-details.component').then(m => m.InvoiceDetailsComponent),
    },
    {
        path: 'LC_ESIC',
        loadComponent: () => import('./pages/esic-tic/lc-esic/lc-esic.component').then(m => m.LCESICComponent),
    },
    {
        path: 'PODetails',
        loadComponent: () => import('./pages/invoice-files/po-details/po-details.component').then(m => m.PoDetailsComponent),
    },
    {
        path: 'CriticalDocuments',
        loadComponent: () => import('./pages/critical-documents/critical-documents/critical-documents.component').then(m => m.CriticalDocumentsComponent),
    },
    {
        path: 'ClientDocuments',
        loadComponent: () => import('./pages/client-documents/client-documents/client-documents.component').then(m => m.ClientDocumentsComponent),
    },
    {
        path: 'DocumentRepository',
        loadComponent: () => import('./pages/client-documents/client-documents/client-documents.component').then(m => m.ClientDocumentsComponent),
    },
    {
        path: 'NoticeClientPortal',
        loadComponent: () => import('./pages/notices/notice-client-portal/notice-client-portal.component').then(m => m.NoticeClientPortalComponent),
    },
    {
        path: 'InputFilesClient',
        loadComponent: () => import('./pages/inputfiles/input-files-client/input-files-client.component').then(m => m.InputFilesClientComponent),
    },
    {
        path: 'InvoiceCreation',
        loadComponent: () => import('./pages/invoice-files/invoice-creation/invoice-creation.component').then(m => m.InvoiceCreationComponent),
    },
    {
        path: 'GstUpload',
        loadComponent: () => import('./pages/invoice-files/gst-upload/gst-upload.component').then(m => m.GstUploadComponent),
    },
    {
        path: 'LC_MyReportsMonthly',
        loadComponent: () => import('./pages/compliance-summary/lc-my-reports-monthly/lc-my-reports-monthly.component').then(m => m.LCMyReportsMonthlyComponent),
    },
    {
        path: 'LC_MyReportsOnboarding',
        loadComponent: () => import('./pages/compliance-summary/lc-my-reports-onboarding/lc-my-reports-onboarding.component').then(m => m.LCMyReportsOnboardingComponent),
    },
    {
        path: 'InvoiceGstUploadApproval',
        loadComponent: () => import('./pages/invoice-files/gst-approval/gst-approval.component').then(m => m.GstApprovalComponent),
    },
    {
        path: 'InvoiceReport',
        loadComponent: () => import('./pages/invoice-files/invoice-report/invoice-report.component').then(m => m.InvoiceReportComponent),
    },
    {
        path: 'OutputChallanCustomer',
        loadComponent: () => import('./pages/inputfiles/output-challan-customer/output-challan-customer.component').then(m => m.OutputChallanCustomerComponent),
    },
    {
        path: 'InputFilesPerformer',
        loadComponent: () => import('./pages/inputfiles/input-files-performer/input-files-performer.component').then(m => m.InputFilesPerformerComponent),
    },
    {
        path: 'OutputChallanPerformer',
        loadComponent: () => import('./pages/inputfiles/output-challan-performer/output-challan-performer.component').then(m => m.OutputChallanPerformerComponent),
    },
    {
        path: 'InvoiceFaceSheet',
        loadComponent: () => import('./pages/invoice-files/invoice-face-sheet/invoice-face-sheet.component').then(m => m.InvoiceFaceSheetComponent),
    },
    {
        path: 'AnchorDashboardSummary',
        loadComponent: () => import('./pages/inputfiles/anchor-dashboard-summaries/anchor-dashboard-summaries/anchor-dashboard-summaries.component').then(m => m.AnchorDashboardSummariesComponent),
    },
    {
        path: 'InvoiceApproval',
        loadComponent: () => import('./pages/invoice-files/invoice-approval/invoice-approval.component').then(m => m.InvoiceApprovalComponent),
    },
    {
        path: 'CreditNote',
        loadComponent: () => import('./pages/invoice-files/creditnote/creditnote.component').then(m => m.CreditnoteComponent),
    },
    {
        path: 'InvoiceDraftToRegular',
        loadComponent: () => import('./pages/invoice-files/invoice-draft-to-regular/invoice-draft-to-regular.component').then(m => m.InvoiceDraftToRegularComponent),
    },
    {
        path: 'AgreementDetails',
        loadComponent: () => import('./pages/master-scoping/agreement-details-master/agreement-details-master.component').then(m => m.AgreementDetailsMasterComponent),
    },
    {
        path: 'CommercialMapping',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping/commercial-mapping.component').then(m => m.CommercialMappingComponent),
    },
    {
        path: 'MasterScopingSetup',
        loadComponent: () => import('./pages/master-scoping/master-scoping-setup/master-scoping-setup.component').then(m => m.MasterScopingSetupComponent),
    },
    {
        path: 'InvoiceUpdation',
        loadComponent: () => import('./pages/invoice-files/invoice-updation/invoice-updation.component').then(m => m.InvoiceUpdationComponent),
    },
    {
        path: 'PrincipleEmployer',
        loadComponent: () => import('./pages/onboard-clra/principle-employer/principle-employer.component').then(m => m.PrincipleEmployerComponent),
    },
    {
        path: 'EmployerLocation',
        loadComponent: () => import('./pages/onboard-clra/employer-location/employer-location.component').then(m => m.EmployerLocationComponent),
    },
    {
        path: 'CreditNoteApproval',
        loadComponent: () => import('./pages/invoice-files/creditnote-approval/creditnote-approval.component').then(m => m.CreditnoteApprovalComponent),
    },
    {
        path: 'Contractor',
        loadComponent: () => import('./pages/onboard-clra/principle-employer-contractor-creation/principle-employer-contractor-creation.component').then(m => m.PrincipleEmployerContractorCreationComponent),
    },
    {
        path: 'PrincipleEmployeeMasterCreation',
        loadComponent: () => import('./pages/onboard-clra/principle-employee-master-creation/principle-employee-master-creation.component').then(m => m.PrincipleEmployeeMasterCreationComponent),
    },
    {
        path: 'NewRegistrationLicense',
        loadComponent: () => import('./pages/registration-licenses/new-registration-license/new-registration-license.component').then(m => m.NewRegistrationLicenseComponent),
    },
    {
        path: 'ExistingRegistrationLicense',
        loadComponent: () => import('./pages/registration-licenses/existing-registration-license/existing-registration-license.component').then(m => m.ExistingRegistrationLicenseComponent),
    },
    {
        path: 'LicenseRequestDetails',
        loadComponent: () => import('./pages/registration-licenses/license-request-details/license-request-details.component').then(m => m.LicenseRequestDetailsComponent),
    },
    {
        path: 'RCPTeam',
        loadComponent: () => import('./pages/registration-licenses/rcp-team/rcp-team.component').then(m => m.RcpTeamComponent),
    },
    {
        path: 'SDExecutor',
        loadComponent: () => import('./pages/registration-licenses/sd-executor/sd-executor.component').then(m => m.SdExecutorComponent),
    },
    {
        path: 'DocumentSection',
        loadComponent: () => import('./pages/registration-licenses/document-section/document-section.component').then(m => m.DocumentSectionComponent),
    },
    {
        path: 'AgreementDetail',
        loadComponent: () => import('./pages/master-scoping/agreement-details-master/agreement-details-master.component').then(m => m.AgreementDetailsMasterComponent),
    },
    {
        path: 'EntityMasters',
        loadComponent: () => import('./pages/onboard-entity/entity-master/entity-master.component').then(m => m.EntityMasterComponent),
    },
    {
        path: 'MasterScopings',
        loadComponent: () => import('./pages/master-scoping//master-scoping-setup//master-scoping-setup.component').then(m => m.MasterScopingSetupComponent),
    },
    {
        path: 'CommercialMappings',
        loadComponent: () => import('./pages/master-scoping/commercial-mapping/commercial-mapping.component').then(m => m.CommercialMappingComponent),
    },
    {
        path: 'ActivityCalenders',
        loadComponent: () => import('./pages/master-scoping/activity-calender/activity-calender.component').then(m => m.ActivityCalenderComponent),
    },
    {
        path: 'CustomerMasters',
        loadComponent: () => import('./pages/onboard-entity/customer-master/customer-master.component').then(m => m.CustomerMasterComponent),
    },
    {
        path: 'NoticeDetails',
        loadComponent: () => import('./pages/notices/edit-notice/edit-notice.component').then(m => m.EditNoticeComponent),
    },
    {
        path: 'SMEResponse',
        loadComponent: () => import('./pages/notices/smeresponse/smeresponse.component').then(m => m.SMEResponseComponent),
    },
    {
        path: 'SDEXENotice',
        loadComponent: () => import('./pages/notices/sdexecuter/sdexecuter.component').then(m => m.SDExecuterComponent),
    },
    {
        path: 'NoticeDocumentSection',
        loadComponent: () => import('./pages/notices/document-section/document-section.component').then(m => m.DocumentSectionComponent),
    },
    {
        path: 'ClientEntityDashboard',
        loadComponent: () => import('./pages/client-dashboard/client-entity-dashboard/client-entity-dashboard.component').then(m => m.ClientEntityDashboardComponent),
    },
    {
        path: 'ClientEntityDashboardGrid',
        loadComponent: () => import('./pages/client-dashboard/client-entity-dashboard-grid/client-entity-dashboard-grid.component').then(m => m.ClientEntityDashboardGridComponent),
    },
    {
        path: 'ComplianceManualUpload',
        loadComponent: () => import('./pages/hr-tech/compliance-manual-upload/compliance-manual-upload.component').then(m => m.ComplianceManualUploadComponent),
    },
    {
        path: 'ForgetPassword',
        loadComponent: () => import('./pages/change-password/change-password.component').then(m => m.ChangePasswordComponent),
    },
    {
        path: 'PremiseAddEdit',
        loadComponent: () => import('./pages/popups/premise-master-add-edit-popup/premise-master-add-edit-popup.component').then(m => m.PremiseMasterAddEditPopupComponent),
    },
    {
        path: 'EntityAddEdit',
        loadComponent: () => import('./pages/popups/add-edit-entity-master/add-edit-entity-master.component').then(m => m.AddEditEntityMasterComponent),
    },
    {
        path: 'ManageEmployeeAddEdit',
        loadComponent: () => import('./pages/popups/add-edit-employee-master-popup/add-edit-employee-master-popup.component').then(m => m.AddEditEmployeeMasterPopupComponent),
    },
    {
        path: 'LocationAddEdit',
        loadComponent: () => import('./pages/popups/employer-location-add-edit/employer-location-add-edit.component').then(m => m.EmployerLocationAddEditComponent),
    },
    {
        path: 'ExistingRegistrationLicenseInitiateView',
        loadComponent: () => import('./pages/popups/existing-license-popup/existing-license-popup.component').then(m => m.ExistingLicensePopupComponent),
    },
    {
        path: 'NewRegistrationLicenseAddNew',
        loadComponent: () => import('./pages/popups/new-registration-licenses-add-popup/new-registration-licenses-add-popup.component').then(m => m.NewRegistrationLicensesAddPopupComponent),
    },
    {
        path: 'ManageEmployeeBulkUpload',
        loadComponent: () => import('./pages/popups/employee-select-bulk-upload/employee-select-bulk-upload.component').then(m => m.EmployeeSelectBulkUploadComponent),
    },
    {
        path: 'CustomerAddEdit',
        loadComponent: () => import('./pages/popups/customer-master-add-edit-popup/customer-master-add-edit-popup.component').then(m => m.CustomerMasterAddEditPopupComponent),
    },
    {
        path: 'EntityBulkUpload',
        loadComponent: () => import('./pages/popups/entity-upload-popup/entity-upload-popup.component').then(m => m.EntityUploadPopupComponent),
    },
    {
        path: 'PremiseBulkUpload',
        loadComponent: () => import('./pages/popups/premise-bulk-upload/premise-bulk-upload.component').then(m => m.PremiseBulkUploadComponent),
    },
    {
        path: 'RegistrationRepositoryAddEdit',
        loadComponent: () => import('./pages/popups/registration-repository-add-edit-popup/registration-repository-add-edit-popup.component').then(m => m.RegistrationRepositoryAddEditPopupComponent),
    },
    {
        path: 'MinimumWagesClientPortal',
        loadComponent: () => import('./pages/ELibrary/minimum-wages-client-portal/minimum-wages-client-portal.component').then(m => m.MinimumWagesClientPortalComponent),
    },
    {
        path: 'ListOfHolidaysClientPortal',
        loadComponent: () => import('./pages/ELibrary/list-of-holidays/list-of-holidays.component').then(m => m.ListOfHolidaysComponent),
    },
    {
        path: 'ListofHolidays',
        loadComponent: () => import('./pages/holiday-masters/list-of-holidays/list-of-holidays.component').then(m => m.ListOfHolidaysComponent),
    },
    {
        path: 'NewsLetter',
        loadComponent: () => import('./pages/ELibrary/news-letter-super-admin-letter/news-letter-super-admin-letter.component').then(m => m.NewsLetterSuperAdminLetterComponent),
    },
    {
        path: 'ListofHolidaysNotifications',
        loadComponent: () => import('./pages/popups/notifications/notifications.component').then(m => m.NotificationsComponent),
    },
    {
        path: 'ConsolidatedStatusReport',
        loadComponent: () => import('./pages/reports/consolidated-status-report/consolidated-status-report.component').then(m => m.ConsolidatedStatusReportComponent),
    },
    {
        path: 'AddEditDraftRCPComponent',
        loadComponent: () => import('./pages/popups/add-edit-draft-rcp/add-edit-draft-rcp.component').then(m => m.AddEditDraftRCPComponent),
    },
    {
        path: 'ER1Returns',
        loadComponent: () => import('./pages/workspace/returns-activity/ER1-returns/ER1-returns-performer/er1-returns/er1-returns.component').then(m => m.Er1ReturnsComponent),
    },
    {
        path: 'ER1AckBulkUpload',
        loadComponent: () => import('./pages/workspace/returns-activity/ER1-returns/ER1-returns-performer/er1-ack-bulk-upload/er1-ack-bulk-upload.component').then(m => m.Er1AckBulkUploadComponent),
    }, 
    {
        path: 'ER1TotalBranches',
        loadComponent: () => import('./pages/popups/er1-total-branches/er1-total-branches.component').then(m => m.Er1TotalBranchesComponent),
    },  
    {
        path: 'SealAndSignMaster',
        loadComponent: () => import('./pages/signatorymaster/sealandsignature/sealandsignature.component').then(m => m.SealandsignatureComponent),
    },
    {
        path: 'LoginUpload',
        loadComponent: () => import('./pages/workspace/returns-activity/ER1-returns/ER1-returns-performer/login-upload/login-upload.component').then(m => m.LoginUploadComponent),
    },
    {
        path: 'CustomerUserMapping',
        loadComponent: () => import('./pages/onboard-entity/customer-user-mapping/customer-user-mapping.component').then(m => m.CustomerUserMappingComponent),
    },
    {
        path: 'ListOfEntities',
        loadComponent: () => import('./pages/onboard-entity/list-of-entities/list-of-entities.component').then(m => m.ListOfEntitiesComponent),
    },
    {
        path: 'Audit',
        loadComponent: () => import('./pages/workspace/returns-activity/ER1-returns/ER1-returns-auditor/audit/audit.component').then(m => m.AuditComponent),
    },
    {
        path: 'AuditReturnsActivity',
        loadComponent: () => import('./pages/workspace/returns-activity/ER1-returns/ER1-returns-auditor/returns-activity/returns-activity.component').then(m => m.ReturnsActivityComponent),
    },
    {
        path: 'AuditorLog',
        loadComponent: () => import('./pages/workspace/returns-activity/ER1-returns/ER1-returns-auditor/auditor-log-grid/auditor-log-grid.component').then(m => m.AuditorLogGridComponent),
    },
    {
        path: 'AuditAllDocuments',
        loadComponent: () => import('./pages/popups/audit-add-edit/audit-add-edit.component').then(m => m.AuditAddEditComponent),
    },
    {
        path:'InternalDashboard',
        loadComponent: () => import('./pages/tl-management-dashboard/tl-management-dashboard/tl-management-dashboard.component').then(m => m.TlManagementDashboardComponent),
    },
    {
        path:'TlManagementInternalDashboard',
        loadComponent: () => import('./pages/tl-management-dashboard/tl-management-internal-dashboard/tl-management-internal-dashboard.component').then(m => m.TlManagementInternalDashboardComponent),
    },
    {
        path:'InternalDashboardPendingGrid',
        loadComponent: () => import('./pages/tl-management-dashboard/internal-dashboard-pending-grid/internal-dashboard-pending-grid.component').then(m => m.InternalDashboardPendingGridComponent),
    },
    {
        path:'InternalDashboardListOfEntities',
        loadComponent: () => import('./pages/tl-management-dashboard/tl-management-list-of-entities/tl-management-list-of-entities.component').then(m => m.TlManagementListOfEntitiesComponent),
    },
     {
        path: 'RCPHeadDashboard',
        loadComponent: () => import('./pages/rcp-head-dashboard/rcp-head-dashboard/rcp-head-dashboard.component').then(m => m.RcpHeadDashboardComponent),
    },
    {
        path: 'RCPHeadDashboardGrid',
        loadComponent: () => import('./pages/rcp-head-dashboard/rcp-head-dashboard-grid/rcp-head-dashboard-grid.component').then(m => m.RcpHeadDashboardGridComponent),
    },
    {
        path: 'RCPHeadDashboardSubGrid',
        loadComponent: () => import('./pages/rcp-head-dashboard/rcphead-sub-grid/rcphead-sub-grid.component').then(m => m.RCPHeadSubGridComponent),
    }, 
    {
        path: 'LabourWelfareFund',
        loadComponent: () => import('./pages/ELibrary/labour-welfare-fund/labour-welfare-fund.component').then(m => m.LabourWelfareFundComponent),
    },
    {
        path: 'LWFViewApplicablity',
        loadComponent: () => import('./pages/ELibrary/lwfview-applicablity/lwfview-applicablity.component').then(m => m.LWFViewApplicablityComponent),
    },
    {
        path: 'PTRepository',
        loadComponent: () => import('./pages/ELibrary/ptrepository/ptrepository.component').then(m => m.PTRepositoryComponent),
    },
    {
        path: 'PTRepositoryApplicable',
        loadComponent: () => import('./pages/ELibrary/ptrepository-applicable/ptrepository-applicable.component').then(m => m.PTRepositoryApplicableComponent),
    },
    {
        path: 'DOLReactivation',
        loadComponent: () => import('./pages/onboard-employee/dol-reactivation/dol-reactivation.component').then(m => m.DolReactivationComponent),
    },
    {
        path:'ENewsLetter',
        loadComponent: () => import('./pages/ELibrary/e-news-letter/e-news-letter.component').then(m => m.ENewsLetterComponent),
    },
    {
        path:'NewsLetterClientPortal',
        loadComponent: () => import('./pages/ELibrary/news-letter/news-letter.component').then(m => m.NewsLetterComponent),
    },
    {
        path:'DailyUpdates',
        loadComponent: () => import('./pages/ELibrary/daily-updates/daily-updates.component').then(m => m.DailyUpdatesComponent),
    },
    {
        path:'LeavetypeMapping',
        loadComponent: () => import('./pages/manage-masters/leavetype-mapping/leavetype-mapping.component').then(m => m.LeavetypeMappingComponent),
    },
    {
        path:'AckUpload',
        loadComponent: () => import('./pages/workspace/returns-activity/ack-upload/ack-upload-performer/ack-upload/ack-upload.component').then(m => m.AckUploadComponent),
    },
    {
        path:'AckUploadGrid',
        loadComponent: () => import('./pages/workspace/returns-activity/ack-upload/ack-upload-performer/ack-upload-grid/ack-upload-grid.component').then(m => m.AckUploadGridComponent),
    },
    {
        path:'AckUploadAuditor',
        loadComponent: () => import('./pages/workspace/returns-activity/ack-upload/ack-upload-auditor/ackauditor/ackauditor.component').then(m => m.ACKAuditorComponent),
    },
    {
        path:'AckUploadAuditorGrid',
        loadComponent: () => import('./pages/workspace/returns-activity/ack-upload/ack-upload-auditor/ackauditor-grid/ackauditor-grid.component').then(m => m.ACKAuditorGridComponent),
    },
    {
        path:'AckUploadAuditorEdit',
        loadComponent: () => import('./pages/popups/ack-upload-edit/ack-upload-edit.component').then(m => m.AckUploadEditComponent),
    },
    {
        path:'EventsMastersCoordinator',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/events-masters-coordinator/events-masters-coordinator.component').then(m => m.EventsMastersCoordinatorComponent),
    },
    {
        path: 'UANCredentials',
        loadComponent: () => import('./pages/automation/uan-credentials/uan-credentials.component').then(m => m.UanCredentialsComponent),
    },
    {
        path: 'UANUploadTagging',
        loadComponent: () => import('./pages/automation/uan-upload-tagging/uan-upload-tagging.component').then(m => m.UanUploadTaggingComponent),
    },
    {
        path:'Displays',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/displays/displays.component').then(m => m.DisplaysComponent),

    },
    {
        path:'ClientDisplay',
        loadComponent: () => import('./pages/events-masters/client-portal/display-client-portal/display-client-portal.component').then(m => m.DisplayClientPortalComponent),

    },
    {
        path:'Repository',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/repository/repository.component').then(m => m.RepositoryComponent),
    },
    {
        path:'NewRequest',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/new-request/new-request.component').then(m => m.NewRequestComponent),

    },
    {
        path:'EventsMastersGrid',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/events-masters-grid/events-masters-grid.component').then(m => m.EventsMastersGridComponent),
    },
    {
        path:'AddEditEventsMasterCoordinator',
        loadComponent: () => import('./pages/popups/add-edit-events-master-coordinator/add-edit-events-master-coordinator.component').then(m => m.AddEditEventsMasterCoordinatorComponent),
    },
    {
        path:'AddNewEventsMasterComponent',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/add-new-events-master/add-new-events-master.component').then(m => m.AddNewEventsMasterComponent),
    },
    {
        path:'Initiate',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/initiate/initiate.component').then(m => m.InitiateComponent),
    },
    {
        path:'RepositoryList',
        loadComponent: () => import('./pages/events-masters/co-ordinator-events-masters/repository-list/repository-list.component').then(m => m.RepositoryListComponent),
    },
    {
        path: 'Error/:code',
        loadComponent: () => import('./pages/ErrorPages/error-page/error-page.component').then(m => m.ErrorPageComponent),
    },
    {
        path: '**',
        redirectTo: '/Error/404.',
    },
];

// Public route segments reachable without an authenticated session.
const PUBLIC_ROUTE_SEGMENTS = new Set(['', 'Login', 'ForgetPassword', 'SSO', 'Auth', 'Error']);

// Enforce role-based authorization BEFORE a restricted component is activated.
// Every non-public, component-rendering route gets the CanActivate guard, so a
// restricted page can never render first and then bounce to /Error/403.
export const appRoutes: Routes = rawAppRoutes.map(route => {
    const firstSegment = typeof route.path === 'string' ? route.path.split('/')[0] : '';
    if (route.path === '**' || route.redirectTo || PUBLIC_ROUTE_SEGMENTS.has(firstSegment)) {
        return route;
    }
    return { ...route, canActivate: [...(route.canActivate ?? []), authRouteGuard] };
});
